import { render, staticRenderFns } from "./RadioButtons.vue?vue&type=template&id=1dda05e6"
import script from "./RadioButtons.vue?vue&type=script&lang=ts"
export * from "./RadioButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports